import styled from 'styled-components';
import { SYS_SIZE_FIXED_100, SYS_SIZE_FIXED_50, SYS_SIZE_FIXED_1000 } from '../../tokens/sizing.generated.js';
const enhancedTouchArea = '24px';
export const StyledPageIndicator = styled.ul `
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: flex-end;
  column-gap: ${SYS_SIZE_FIXED_100};
  min-height: ${SYS_SIZE_FIXED_100};
`;
export const StyledListItem = styled.li `
  list-style-type: none;
  line-height: 0;
  flex: 1;
`;
export const StyledPageIndicatorItemButton = styled.button `
  display: flex;
  border: 0;
  position: relative;
  height: ${(props) => (props.active ? SYS_SIZE_FIXED_100 : SYS_SIZE_FIXED_50)};
  width: ${SYS_SIZE_FIXED_1000};
  background-color: ${(props) => props.active
    ? props.theme.sem.color.navigation.foreground.indicator.active
    : props.theme.sem.color.navigation.foreground.indicator.inactive};

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: ${enhancedTouchArea};
    z-index: 1;
    cursor: pointer;
    min-width: ${enhancedTouchArea};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
//# sourceMappingURL=index.styles.js.map